import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollButton"]

  scrollToNext() {
    const section = this.element
    const nextSection = section.nextElementSibling
    
    if (nextSection && nextSection.tagName.toLowerCase() === 'section') {
      nextSection.scrollIntoView({ behavior: 'smooth' })
    }
  }
}